import { render } from "./scenario-user-assignment.vue?vue&type=template&id=4b8bbc23&ts=true"
import script from "./scenario-user-assignment.vue?vue&type=script&lang=ts"
export * from "./scenario-user-assignment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__